import React, { useLayoutEffect, useState } from "react";
import { Switch, BrowserRouter as Router, Route } from "react-router-dom";

import "./Dashboard.css";

import { getCookie } from "../utility/Cookie";

import NavbarDashboard from "./NavbarDashboard";
import AddCourse from "./pages/AddCourse";
import { Redirect } from "react-router-dom";
import AddInstructor from "./pages/AddInstructor";
import AddVideo from "./pages/AddVideo";
import AllCourses from "./pages/AllCourses";
import AllInstructors from "./pages/AllInstructors";
import AddQuestions from "./pages/AddQuestions";
import AddStory from "./pages/AddStory";
import Pricing from "./pages/Pricing";
import AllStories from "./pages/AllStories";
import AllQuestions from "./pages/AllQuestions";
import AllUsers from "./pages/AllUsers";
import EditUser from "./pages/edit/EditUser";
import NotFound from "../Pages/NotFound";

const Dashboard = () => {
  const token = getCookie("_t_");

  useLayoutEffect(() => {
    if (!token) {
      <Redirect to="/admin" />;
    } else {
      <Redirect to="/dashboard/" />;
    }
  }, [token]);

  return (
    <div className="dashboard">
      <div className="dashboard-container">
        <Router>
          <div className="dashboard-right">
            <NavbarDashboard />
          </div>
          <div className="dashboard-left">
            <Switch>
              <Route path="/dashboard/addcourse" exact component={AddCourse} />
              <Route
                path="/dashboard/addinstructor"
                component={AddInstructor}
              />
              <Route path="/dashboard/addvideo" component={AddVideo} />
              <Route path="/dashboard/allcourses" component={AllCourses} />

              <Route
                path="/dashboard/allinstructors"
                component={AllInstructors}
              />
              <Route path="/dashboard/all-stories" component={AllStories} />
              <Route path="/dashboard/all-questions" component={AllQuestions} />
              <Route path="/dashboard/all-users" component={AllUsers} />
              <Route path="/dashboard/add-questions" component={AddQuestions} />
              <Route
                path="/dashboard/edit-question/:id"
                component={AddQuestions}
              />
              <Route path="/dashboard/add-story" component={AddStory} />
              <Route path="/dashboard/edit-story/:id" component={AddStory} />
              <Route path="/dashboard/edit-user/:id" component={EditUser} />
              <Route path="/dashboard/pricing" component={Pricing} />
              <Route path="/dashboard/*" component={NotFound} />

            </Switch>
          </div>
        </Router>
      </div>
    </div>
  );
};

export default Dashboard;
